import {LOGIN_URL} from "./API";


export const redirectToSignInPage = () => {
    const currentUrl = window.location.origin+window.location.pathname+'#/';
    window.location.replace(`${LOGIN_URL}?callback=${currentUrl}`);
}